// import $ from 'jquery';
import React from 'react'
import Field from './Field'
import { isInt, isNumeric } from 'validator'
import { countDecimals } from '../../_utils'
// import PropTypes from 'prop-types';

class FieldNumber extends Field {
  constructor(props) {
    super(props)
  }
  formatStrict(value) {
    const { min, max } = this.props
    if (!value) return value
    if (min !== false && Number(value) < min) {
      return min
    } else if (max !== false && Number(value) > max) {
      return max
    }
    return value
  }
  format(value) {
    const { strict, allowDecimals, maxDecimals } = this.props
    const isNegative = /[-]/.test(value)
    let newValue = value.replace(/[^0-9.]/g, '')

    // allowDecimals
    if (allowDecimals) {
      if (maxDecimals > 0) {
        if (countDecimals(value) > maxDecimals) {
          const modifier = Math.pow(10, maxDecimals)
          newValue = Math.floor(newValue * modifier) / modifier
        }
      }
    } else {
      newValue = newValue.replace(/[^0-9-]/g, '')
    }

    // negative
    if (isNegative) {
      newValue = '-' + newValue
    }

    // strict mode
    if (strict) {
      newValue = this.formatStrict(newValue)
    }

    return Number(newValue)
  }
  validate() {
    const { value, min, max } = this.props
    let condition = true

    if (min && max) {
      condition = isInt(String(value), { min: min, max: max })
    } else if (min) {
      condition = isInt(String(value), { gt: min - 1 })
    } else if (max) {
      condition = isInt(String(value), { lt: max + 1 })
    }

    return super.validate() && isNumeric(String(value)) && condition
  }
  onKeyPress(e) {
    e.stopPropagation()
    // const { lastInput, lastValue } = this;
    const { value } = e.target
    const formattedValue = this.format(value)
    // const charCode = e.which || e.keyCode;
    // const charStr = String.fromCharCode(charCode);
    // const altKeys = e.ctrlKey || e.metaKey || e.altKey;

    // console.log(value, '  charStr:', charStr, '  lastInput:', this.lastInput, '   altkeys:', altKeys);

    // if (!value && !altKeys && !/[\d-]/.test(charStr)) {
    // if (!value || !/[\d-]/.test(charStr)) {
    if (!/\d+(\.\d*)?|\.\d+/.test(formattedValue)) {
      console.log('prevent')
      e.preventDefault()
    }
  }
  render() {
    const { animatedLabel, min, max, allowDecimals } = this.props

    return (
      <label className={this.handleClasses()} data-label={animatedLabel} ref={(r) => (this.field = r)}>
        {super.renderLabel()}
        {super.renderAutoresize()}
        <input
          className="field__input"
          ref={(r) => (this.input = r)}
          {...super.generateProps()}
          // type="text"
          type="number"
          min={min}
          max={max}
          step={allowDecimals ? 'any' : 1}
        />
        {super.renderError()}
      </label>
    )
  }
}

export default FieldNumber
